// UTM parameter capture — stores first-touch UTMs in sessionStorage
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign'];

/**
 * Capture UTM params from the current URL into sessionStorage.
 * First-touch wins: does not overwrite if already captured this session.
 */
export function captureUtmParams() {
  // Skip if already captured this session
  if (sessionStorage.getItem('utm_source')) return;

  const params = new URLSearchParams(window.location.search);
  for (const key of UTM_KEYS) {
    const val = params.get(key);
    if (val) sessionStorage.setItem(key, val);
  }
}

/**
 * Get captured UTM data from sessionStorage.
 * Returns null if no UTMs were captured.
 */
export function getUtmData() {
  const source = sessionStorage.getItem('utm_source');
  if (!source) return null;

  return {
    utm_source: source,
    utm_medium: sessionStorage.getItem('utm_medium'),
    utm_campaign: sessionStorage.getItem('utm_campaign'),
  };
}

/**
 * Clear captured UTM data from sessionStorage (after persisting to backend).
 */
export function clearUtmData() {
  for (const key of UTM_KEYS) {
    sessionStorage.removeItem(key);
  }
}
